<template>
  <div class="d-flex flex-column gap-4">
    <p v-html="header" class="my-4"></p>
    <p
      class="font-size-x-small"
      v-if="Boolean(featureData.subtitle)"
      v-html="featureData.subtitle"></p>

    <template v-if="isFeatureInstalled">
      <h5>{{ $t('customForms.messages.formAvailableFor') }}:</h5>

      <v-expansion-panels elevation="0" flat>
        <v-expansion-panel
          readonly
          v-for="trigger of triggers"
          :key="trigger.id"
          class="border mb-2">
          <v-expansion-panel-title class="cursor-default">
            <div>
              <span>{{ $t(`global.specialtyTerms.${camelCase(trigger.app)}s`) }}</span>
              <v-icon
                class="ml-2"
                :data-testid="`feature-status-${trigger.app}`"
                :title="
                  trigger.isActive
                    ? $t('customForms.messages.formActive')
                    : $t('customForms.messages.formNotVisible')
                "
                :color="trigger.isActive ? 'success' : 'grey'"
                size="x-small">
                mdi-circle
              </v-icon>
            </div>
            <template v-slot:actions>
              <v-btn
                size="small"
                variant="flat"
                @click="$emit('manage', trigger)"
                :data-testid="`feature-manage-${trigger.app}`">
                {{ $t('customForms.buttons.manage') }}
                <v-icon size="small" class="ml-2">mdi-arrow-right</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <div v-else class="my-4">
      <strong>
        <v-icon color="red" class="mr-2">mdi-alert-circle</v-icon>
        {{ $t('global.phrases.featureDisabled') }}
      </strong>
    </div>
  </div>
</template>

<script>
import { getTranslatedCustomFormsFeaturesData } from '@nova/core';
import { camelCase } from 'lodash';

export default {
  methods: { camelCase },
  props: {
    feature: {
      type: String,
      required: true
    },
    triggers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    featureData() {
      return getTranslatedCustomFormsFeaturesData()[this.feature] || {};
    },
    header() {
      return `${this.featureData.description} ${this.featureData.helpLink}`;
    },
    isFeatureInstalled() {
      return (
        this.triggers?.length > 0 &&
        this.triggers
          .filter(trigger => trigger.feature === this.feature)
          .every(trigger => trigger.flow)
      );
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.cursor-default {
  cursor: default !important;
}
</style>
